// extracted by mini-css-extract-plugin
export default {"RoundCornerContainer_container":"RoundCornerContainer_RoundCornerContainer_container__s1IxA"};